import { render, staticRenderFns } from "./approvalDetail.vue?vue&type=template&id=2d0f6c96&scoped=true"
import script from "./approvalDetail.vue?vue&type=script&lang=js"
export * from "./approvalDetail.vue?vue&type=script&lang=js"
import style0 from "./approvalDetail.vue?vue&type=style&index=0&id=2d0f6c96&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f6c96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer-copy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d0f6c96')) {
      api.createRecord('2d0f6c96', component.options)
    } else {
      api.reload('2d0f6c96', component.options)
    }
    module.hot.accept("./approvalDetail.vue?vue&type=template&id=2d0f6c96&scoped=true", function () {
      api.rerender('2d0f6c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/approval/approvalDetail.vue"
export default component.exports